const locationError = {
  alert: 'Enable this website location service in your browser settings',
  else: 'Unable to access your location',
  else1: 'Geolocation service not available in your browser'
};

export default locationError;
